import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"

if (!window.appElasticsearchUrl) {
  throw new Error(`appElasticsearchUrl is empty ${window.appElasticsearchUrl}`)
}

const domNode = document.getElementById("search-root")
const root = createRoot(domNode)
root.render(<App />)
